export const faqs = [
  {
    q: 'Is this really for beginners?',
    a: [
      'Yes. The system is structured progressively, starting with the foundation and moving through the different phases toward race execution.',
      "You don't need to already be an advanced triathlete to understand the framework.",
    ],
  },
  {
    q: 'Do I need a coach to use the system?',
    a: [
      'No. THE FULL DISTANCE TRIATHLON SYSTEM™ is designed as a self-guided digital resource.',
      'If you already work with a qualified coach, the system can also serve as an additional organizational and educational resource.',
    ],
  },
  {
    q: 'Do I need a gym?',
    a: [
      'Not necessarily. The system focuses on organizing your overall endurance preparation. Specific equipment requirements will depend on the individual training approach you choose to follow.',
    ],
  },
  {
    q: 'Is this a physical book?',
    a: [
      'No. The entire product is delivered digitally in PDF format.',
      'You can access your material from compatible smartphones, tablets, laptops and other devices.',
    ],
  },
  {
    q: 'Is this a one-time payment?',
    a: [
      'Yes. There are no recurring subscription fees for the main product.',
      'You make one payment and receive lifetime access to the purchased digital material.',
    ],
  },
  {
    q: 'How do I access the material?',
    a: [
      "After your purchase, you'll receive instant digital access to the system. You can begin accessing your materials immediately from your compatible device.",
    ],
  },
  {
    q: 'Does it include the four bonuses?',
    a: [
      'Yes. The 40-Week Triathlete Training Calendar™, Triathlete Fueling Vault™, Race Week Command Center™ and Triathlete Progress Tracker™ are included with the current offer.',
    ],
  },
  {
    q: 'Can I use it on Android and iOS?',
    a: [
      'Yes. The digital materials are designed to be accessible across commonly used devices, including Android and iOS.',
    ],
  },
  {
    q: 'Is this a personalized coaching service?',
    a: [
      'No. THE FULL DISTANCE TRIATHLON SYSTEM™ is an educational digital resource designed to provide structure, organization and practical frameworks.',
      'It does not replace individualized coaching, medical advice or professional sports guidance.',
    ],
  },
];

export const steps = [
  {
    n: '1',
    title: 'Instant download',
    body: 'Purchase THE FULL DISTANCE TRIATHLON SYSTEM™ and instantly access the complete 6-phase system and four performance bonuses. No shipping. No waiting. Start when you’re ready.',
    tags: [] as string[],
    after: '',
  },
  {
    n: '2',
    title: 'Build your training system',
    body: 'Work through the six phases and organize your preparation around:',
    tags: ['Swim', 'Bike', 'Run', 'Strength', 'Recovery', 'Fueling', 'Progress'],
    after: 'Instead of constantly asking “What should I do next?”, you have a complete framework to work from.',
  },
  {
    n: '3',
    title: 'Execute your race',
    body: 'As race day approaches, use your included performance tools to organize:',
    tags: ['Your training', 'Your fueling', 'Your progress', 'Your equipment', 'Your race week', 'Your race execution'],
    after: '',
  },
];
